var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-navigator-wrap"},[_c('i',{staticClass:"back",on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('Tool'),_c('i',{staticClass:"setting",on:{"click":function($event){return _vm.$emit('setting')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }